export default __webpack_public_path__ + "static/media/studentRealCase1-en.0d5c411e.png";